const PARROBOT_TOGGLE_SHOW = 'bfb/parrobot/PARROBOT_TOGGLE_SHOW';

export default {
  PARROBOT_TOGGLE_SHOW,
};
